import EditButtonRendered from "../_components/EditButtonRendered";

export const studentGroupColumnDefs = ({setOpenEditModal, setSelectedRowData}) =>  [
  {
    headerName: 'Group Name',
    field: 'groupName',
    flex: 1,
  },
  {
    headerName: 'Group Type',
    field: 'groupType',
    width: 120,
  },
{
  headerName: 'Params',
  field: 'params',
  width: 250,
  valueGetter: (params) => {
    const paramsData = params?.data?.params;

    if (paramsData && typeof paramsData === 'object') {
      // Pick a non-zero value from userIdLength or userEmailLength
      const userCount =
        paramsData.userIdLength === 0 ? paramsData.userEmailLength :
        paramsData.userEmailLength === 0 ? paramsData.userIdLength :
        paramsData.userEmailLength; 
      return `Type: ${paramsData.type || 'N/A'}, Users: ${userCount || 0}`;
    }

    return 'N/A';
  },
},
  {
    headerName: 'Group Description',
    field: 'groupDecr',
    flex: 1,
  },
  {
    headerName: 'Created At',
    field: 'createdAt',
    width: 180,
    valueGetter: (params) => {
      const date = params?.data?.createdAt;
      return date ? new Date(date).toLocaleDateString() : 'N/A';
    },
  },
  {
    headerName: 'Created By',
    field: 'createdBy',
    width: 200,
  },
  {
    headerName: 'Deleted At',
    field: 'deletedAt',
    width: 180,
    valueGetter: (params) => {
      const date = params?.data?.deletedAt;
      return date ? new Date(date).toLocaleDateString() : 'NA';
    },
  },
  {
    headerName: 'Actions',
    field: 'action',
    width: 180,
    pinned: 'right',
    cellRenderer: EditButtonRendered,
    cellRendererParams: {
      setOpenEditModal,
      setSelectedRowData
    },
  },
];